import React, { Component } from "react";
import { HiExternalLink } from "react-icons/hi";
import sampleimage from './sampleimage.png';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoMdArrowRoundForward } from "react-icons/io";
import ShowMoreText from "react-show-more-text";
import "./Auction.css";

const {
  REACT_APP_IS_MAINNET,
} = process.env;

class Auction extends Component {
  constructor(props) {
    super(props);

    this.getTimeLeft = this.getTimeLeft.bind(this);
    this.handleBidAmountChange = this.handleBidAmountChange.bind(this);
    this.placeBid = this.placeBid.bind(this);
    this.settleBid = this.settleBid.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleForwardClick = this.handleForwardClick.bind(this);

    this.state = {
      timeLeft: null,
      bidAmount: '',
      chosenAuction: null,
      chosenAuctionIndex: -1
    }
  }

  componentDidMount() {
    setInterval(this.getTimeLeft, 1000);
    this.setState({
      chosenAuction: this.props.collectionDetails.latestAuction,
      chosenAuctionIndex: this.props.collectionDetails.allAuctions.length - 1,
    });
  }

  handleBackClick() {
    if(this.state.chosenAuctionIndex <= 0) {
      return;
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "auctions",
      "auctions_click_back",
      "info",
      "https://the402.xyz",
      {}
    );
    this.setState({
      chosenAuctionIndex: this.state.chosenAuctionIndex - 1,
      chosenAuction: this.props.collectionDetails.allAuctions[this.state.chosenAuctionIndex - 1]
    });
  }

  handleForwardClick() {
    if(this.state.chosenAuctionIndex >= this.props.collectionDetails.allAuctions.length - 1) {
      return;
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "auctions",
      "auctions_click_forward",
      "info",
      "https://the402.xyz",
      {}
    );
    this.setState({
      chosenAuctionIndex: this.state.chosenAuctionIndex + 1,
      chosenAuction: this.props.collectionDetails.allAuctions[this.state.chosenAuctionIndex + 1]
    });
  }

  getTimeLeft() {
    if(this.state.chosenAuction == null) {
      return "--";
    }
    let msLeft = this.state.chosenAuction.endTime*1000 - Date.now();
    let secondsLeft = Math.floor(msLeft / 1000);
    if(secondsLeft <= 0) {
      this.setState({
        timeLeft: "Over",
      });
      return;
    }
    let hours = Math.floor(secondsLeft / 3600);
    secondsLeft -= hours * 3600;
    let minutes = Math.floor(secondsLeft / 60);
    secondsLeft -= minutes * 60;
    let seconds = Math.floor(secondsLeft);
    let timeLeft = hours + "h " + minutes + "m " + seconds + "s ";
    this.setState({
      timeLeft,
    });
  }

  checkStringWithDecimal(str) {
    return !str.includes("-") && !isNaN(str) && parseFloat(str) >= 0;
  }

  handleBidAmountChange(event) {
    if(this.checkStringWithDecimal(event.target.value) || event.target.value === "") {
      this.setState({
        bidAmount: event.target.value
      });
    }
  }

  async placeBid() {
    if(this.props.account == null || this.props.collectionDetails.latestAuction.nounId !== this.state.chosenAuction.nounId) {
      return;
    }
    this.props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.placeBid(this.props.account.address, this.props.collectionDetails.latestAuction, this.state.bidAmount);
    if(!didApprove) {
      this.props.setTransactionStatus("None");
    } else {
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "auctions",
        "auctions_place_bid",
        "info",
        "https://the402.xyz",
        {}
      );
    }
  }

  async settleBid() {
    if(this.props.account == null || this.props.collectionDetails.latestAuction.nounId !== this.state.chosenAuction.nounId) {
      return;
    }
    this.props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.settleBid(this.props.account.address, this.props.collectionDetails.latestAuction);
    if(!didApprove) {
      this.props.setTransactionStatus("None");
    } else {
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "auctions",
        "auctions_settle_bid",
        "info",
        "https://the402.xyz",
        {}
      );
    }
  }

  render() {
    if(this.state.chosenAuction == null) {
      return (
        <div className="flex-col flex md:flex-row h-auto md:min-h-[32rem] items-center w-full xl:w-8/12 justify-around">
        </div>
      );
    }
    let minBid = this.state.chosenAuction.reservePrice / 1000000000000000000;
    let date = new Date(this.state.chosenAuction.startTime*1000);
    let formattedDate = date.toDateString();
    let formattedDateSplit = formattedDate.split(" ");
    formattedDateSplit[formattedDateSplit.length - 2] = formattedDateSplit[formattedDateSplit.length - 2] + ",";
    formattedDate = formattedDateSplit.slice(1).join(" ");
    minBid = Math.max(minBid, parseFloat(this.state.chosenAuction.amount / 1000000000000000000)*1.02);
    minBid = Math.round(minBid * 1000) / 1000;

    // TODO undo immigrant parents hard coding

    return (
      <div className="flex-col flex md:flex-row h-auto md:min-h-[32rem] items-center w-full xl:w-8/12 justify-around">
        <div className="h-auto md:min-h-[32rem] items-center sm:items-start justify-center flex flex-col">
          {
            this.state.chosenAuction.mediaType === 2
              ?
            <img
              className="w-80 sm:w-96 mt-2 sm:mt-20 rounded-lg cursor-pointer"
              src={this.state.chosenAuction.imagePinata}
              onClick={() => {
                if(!this.props.isFromCollections) {
                  return;
                }
                loggingUtils.logEvent(
                  this.props.account != null
                    ? this.props.account.address
                    : encryptUtils.getWalletUnconnectedUserId(),
                  "auction_collections_page",
                  "auction_collections_page_click_auction",
                  "info",
                  "https://the402.xyz",
                  {}
                );
                window.location.href = window.location.origin + "/auction/" + this.props.collectionDetails.id;
              }}
            />
              :
            <video
              className="h-96 cursor-pointer"
              src={this.state.chosenAuction.animation_url}
              controls
              muted="muted"
              autoplay="autoplay"
              onClick={() => {
                if(!this.props.isFromCollections) {
                  return;
                }
                loggingUtils.logEvent(
                  this.props.account != null
                    ? this.props.account.address
                    : encryptUtils.getWalletUnconnectedUserId(),
                  "auction_collections_page",
                  "auction_collections_page_click_auction",
                  "info",
                  "https://the402.xyz",
                  {}
                );
                window.location.href = window.location.origin + "/auction/" + this.props.collectionDetails.id;
              }}
            />
          }
          <div className="text-xl w-80 sm:w-96 font-semibold mt-2 text-black dark:text-white">
          <ShowMoreText
            className = "text-base flex dark:text-white text-black mt-2 flex-col w-80 sm:w-full"
            lines={3}
            more=<span className="text-gray-500 dark:text-zinc-400">Show more</span>
            less=<span className="text-gray-500 dark:text-zinc-400">Show less</span>
            onClick={this.executeOnClick}
            expanded={false}
            truncatedEndingComponent={"..."}
          >
            {
              this.state.chosenAuction.description
            }
          </ShowMoreText>
          </div>
        </div>
        <div className="ml-0 md:ml-8 h-112 flex flex-col justify-between">
          <div className="sm:mt-0 mt-2 flex">
            <div className="bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full cursor-pointer">
              <IoMdArrowRoundBack
                className={
                  this.state.chosenAuctionIndex <= 0
                    ?
                  "text-3xl dark:text-gray-600 text-gray-400"
                    :
                  "text-3xl dark:text-gray-400 text-gray-600"
                }
                onClick={this.handleBackClick}
              />
            </div>
            <div className="bg-gray-200 dark:bg-zinc-800 hover:bg-gray-300 duration-500 rounded-full ml-2 cursor-pointer">
              <IoMdArrowRoundForward
                className={
                  this.state.chosenAuctionIndex >= this.props.collectionDetails.allAuctions.length - 1
                    ?
                  "text-3xl dark:text-gray-600 text-gray-400"
                    :
                  "text-3xl dark:text-gray-400 text-gray-600"
                }
                onClick={this.handleForwardClick}
              />
            </div>
            <div className="text-gray-500 dark:text-zinc-500 ml-4 text-xl font-semibold">
              {formattedDate}
            </div>
          </div>
          <div className="text-5xl font-bold dark:text-white font-nouns">
            {
              this.state.chosenAuction.name.includes("Immigrant Parents")
                ?
              "Immigrant Parents (live with the402)"
                :
              this.state.chosenAuction.name
            }
          </div>
          <div className="flex">
            <div>
              <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                Current bid
              </div>
              <div className="text-3xl font-bold dark:text-white mt-2">
                {this.state.chosenAuction.amount/1000000000000000000 + " ETH"}
              </div>
            </div>
            <div className="ml-8">
              {
                this.state.chosenAuction.name.includes("Immigrant Parents")
                  ?
                <div>
                  <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                    Auction ends on
                  </div>
                  <div className="text-3xl font-bold dark:text-white mt-2">
                    Dec 22, 2022
                  </div>
                </div>
                  :
                this.state.timeLeft != null && this.state.timeLeft === "Over"
                  ?
                <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                  Auction over
                </div>
                  :
                this.state.timeLeft != null
                  ?
                <div>
                  <div className="text-2xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
                    Auction ends in
                  </div>
                  <div className="text-3xl font-bold dark:text-white mt-2">
                    {this.state.timeLeft}
                  </div>
                </div>
                  :
                null
              }
            </div>
          </div>
          <div className="flex mt-4">
            {
              this.state.timeLeft != null && this.state.timeLeft === "Over" && this.props.collectionDetails.latestAuction.nounId === this.state.chosenAuction.nounId && !this.props.collectionDetails.latestAuction.settled
                ?
              <div
                className="cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-2 w-20 sm:w-28 h-14 flex justify-center items-center text-lsm:text-xl font-bold bg-blue-600 rounded-lg text-white"
                onClick={this.settleBid}
              >
                Settle bid
              </div>
                :
              this.state.timeLeft != null && this.state.timeLeft !== "Over"
                ?
              <div className="flex">
                <input
                  type="number"
                  className="p-2 w-60 sm:w-80 text-xl font-bold h-14 bg-gray-200 rounded-lg"
                  min="0"
                  value={this.state.bidAmount}
                  onChange={this.handleBidAmountChange}
                  placeholder={"At least " + minBid + " ETH"}
                >
                </input>
                <div
                  className="cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-2 w-20 sm:w-28 h-14 flex justify-center items-center text-lsm:text-xl font-bold bg-blue-600 rounded-lg text-white"
                  onClick={this.placeBid}
                >
                  Place bid
                </div>
              </div>
                :
              null
            }
          </div>
          <div className="auctionBids">
            {
              this.state.chosenAuction.allAuctionBids.slice().reverse().map(auctionBid => {
                return (
                  <div key={auctionBid.id} className="w-80 mt-2 flex justify-between items-center">
                    <div className="text-lg w-40 font-semibold text-gray-500 dark:text-zinc-500">
                      {auctionBid.bidder.substring(0, 5) + "..." + auctionBid.bidder.substring(auctionBid.bidder.length - 5)}
                    </div>
                    <div className="text-lg w-28 font-semibold text-gray-500 dark:text-zinc-500">
                      {auctionBid.amount / 1000000000000000000 + " ETH"}
                    </div>
                    <div className="text-lg w-10 font-semibold text-gray-500 dark:text-zinc-500 cursor-pointer">
                      <HiExternalLink onClick={
                        () => {
                          loggingUtils.logEvent(
                            this.props.account != null
                              ? this.props.account.address
                              : encryptUtils.getWalletUnconnectedUserId(),
                            "auctions",
                            "auctions_visit_bid_link",
                            "info",
                            "https://the402.xyz",
                            {}
                          );
                          if(REACT_APP_IS_MAINNET !== "testnet") {
                            window.open("https://etherscan.io/tx/" + auctionBid.transactionHash, "_blank");
                          } else {
                            window.open("https://goerli.etherscan.io/tx/" + auctionBid.transactionHash, "_blank");
                          }
                        }
                      }/>
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default Auction;
